@if(doShowModal){
<div class="add-attachment-container">
    <div class="w-100 h-100 position-relative">
        <span class="m-0 p-0" style="position: absolute; top:-1.3rem; right: -1.2rem;" role="button" (click)="hideModal()">
            <i class="pi pi-times" style="font-size: 16px; font-weight: bolder;"></i>
        </span>
        <div class="row">
            <div class="col-12 d-flex justify-content-center align-items-center" style="margin-bottom: 15px; border-bottom: 1px solid black;">
                <h3>File Upload</h3>
            </div>
            <div class="col-12 d-flex justify-content-center align-items-center">
                <div class="attachment-drop-box" draggable="true" ngClass="'addAttachmentDragArea'" role="button" (click)="file.click()">
                    <i class="m-0 p-0 pi pi-cloud-upload" style="font-size: 50px !important;"></i>
                    <span class="m-0 p-0 mt-3">Click or drop you files here</span>
                </div>
                <input type="file"
                    #file
                    [multiple]="true"
                    (change)="onFileChange($event)"
                    accept="image/*,.pdf"
                    style="display:none" />
            </div>
            <div class="col-12 d-flex justify-content-center flex-wrap align-items-center pt-3 mt-3">
                @for (file of files; track file.name) {
                    <div class="file-name-box">
                        <span class="m-0 p-0">{{file.name}}</span>
                        <i class="pi pi-times text-danger" style="margin-left: 12px;" role="button" (click)="removeAddedFile(file)"></i>
                    </div>
                }
            </div>
        </div>
        <div class="modal-footer-buttons">
            <button class="button-cancel float-right" [disabled]="isLoading" type="button" (click)="hideModal()">Cancel</button>
            <button class="button-save float-right" style="margin-right: 15px;" type="button" [disabled]="isLoading" (click)="uploadFiles()">Upload</button>
            @if (isLoading) {
                <div class="loading">
                  <app-loading-indicator />
                </div>
            }
        </div>
    </div>
</div>
}